import React from "react";
import { Compass } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { apiGetList, apiPost, apiPut } from "./adminApi";

const fields = [
  { name: "studyAreaName", label: "Study Area Name", type: "text", required: true, placeholder: "e.g. UR STEM", fullWidth: true },
  {
    name: "studyAreaWeight",
    label: "Weight",
    type: "number",
    required: true,
    min: 0,
    help: "Weight used by the selection algorithm. Higher weight = higher priority.",
  },
];

export default function StudyAreasPage() {
  return (
    <AdminCrudPage
      title="Study Areas"
      subtitle="Study areas (STEM / non-STEM groupings) that qualifications belong to"
      icon={Compass}
      entityName="study area"
      queryKey="adminStudyAreas"
      fetchAll={() => apiGetList("hec/studyArea/getStudyAreas")}
      createItem={(values) => apiPost("hec/studyArea/saveStudyArea", values)}
      updateItem={(id, values, row) =>
        apiPut("hec/studyArea/updateStudyArea", { id, state: row.state, version: row.version, ...values })
      }
      searchKeys={["studyAreaName"]}
      columns={[
        { key: "studyAreaName", label: "Study Area", render: (r) => <span className="font-semibold text-gray-900">{r.studyAreaName}</span> },
        { key: "studyAreaWeight", label: "Weight", render: (r) => <span className="font-mono">{r.studyAreaWeight}</span> },
      ]}
      fields={fields}
      emptyHint="Study areas are required before qualifications can be created."
    />
  );
}
